import React, { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  useGetAllCountMutation,
  useLazyGetUserCsvQuery,
  usePutChangeUserStatusMutation,
} from "../../services/registration";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBar2 from "../../components/SearchBar2";
import Pagination from "../../components/Pagination";
import { errorToast, successToast } from "../../helpers/toast";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import "react-day-picker/dist/style.css";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import WarnModal from "../../components/WarnModal";
import { RejectModal } from "../../components";
import {
  useDeleteCustomerMutation,
  useLazyGetCustomerListQuery,
  useUpdateApprovalStatusMutation,
} from "../../services/registration";
import useTranslation from "../../hooks/Translation";
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const ManageCustomers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const t = useTranslation();
  const [getallusers] = useLazyGetCustomerListQuery();
  const [getAllCount] = useGetAllCountMutation();
  const [updateApprovalStatus] = useUpdateApprovalStatusMutation();
  const [rows, setRows] = useState<any>([]);
  const { pathname } = useLocation();
  const [value, setValue] = React.useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [total_records, settotal_records] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [userCount, setUserCount] = useState<any>("");
  const [userCsv] = useLazyGetUserCsvQuery();
  const [deleteUserById] = useDeleteCustomerMutation();
  const [putChangeUserStatus] = usePutChangeUserStatusMutation();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [rejectOpen, setRejectOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<any>(0);
  const [totalPages, setTotalPages] = useState(1);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  // let totalPages = Math.ceil(total_records / 10);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const FetchAllCount = async () => {
    setIsLoading(true);
    let body = {
      user_role: 2,
      search: debouncedSearchTerm,
    };
    try {
      const response = await getAllCount(body).unwrap();

      if (response.status === 200) {
        setUserCount(response?.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const fetchData = async (page: number, search: string) => {
    setIsLoading(true);
    try {
      const response = await getallusers({
        body: {
          start: page,
          search: searchTerm,
          length: limit,
          status: value + 1,
        },
      }).unwrap();

      if (response.status === 200) {
        setIsLoading(false);
        if (Array.isArray(response?.data?.response_object)) {
          setRows(response?.data?.response_object);
        } else {
          setRows([]);
        }
        settotal_records(response?.data?.total_records);
        setTotalPages(Math.ceil(response?.data?.total_records / 10));
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };
  const ApproveReject = async (id: any, approvalStatus: any) => {
    setIsLoading(true);
    try {
      const response = await updateApprovalStatus({
        id,
        profile_status: approvalStatus,
      }).unwrap();

      if (response.status === 200) {
        if (approvalStatus === 4) {
          successToast(t.main.customerRejected);
        } else if (approvalStatus === 5) {
          successToast(t.main.customerAccepted);
        }
        fetchData(page, searchTerm);
        FetchAllCount();
      } else {
      }
    } catch (error: any) {
      console.error("Error updating approval status:", error);
      errorToast(error?.message || "Failed to update approval status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteUser = async (userId: string) => {
    setIsLoading(true);
    try {
      const response = await deleteUserById({
        id: userId,
        profile_status: "3",
      }).unwrap();
      if (response?.status === 200) {
        successToast(t.main.userDeleted);
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "Failed to delete user");
    } finally {
      setIsLoading(false);
    }
  };

  const changeUserStatus = async (id: string, is_active: boolean) => {
    try {
      const body = { is_active };

      const response = await putChangeUserStatus({
        id,
        is_active: !is_active,
      }).unwrap();
      if (response?.status === 200) {
        if (is_active === false) {
          successToast(t.main.customerAccepted);
        } else {
          successToast(t.main.customerDeactivated);
        }
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error("Error updating status:", error);
    }
  };
  const getUserCsv = async () => {
    try {
      const response = await userCsv({}).unwrap();
      if (response?.status === 200) {
        window?.open(response?.file_urls);
      } else {
        console.log("error");
      }
    } catch (error: any) {}
  };

  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [page, debouncedSearchTerm, limit, value]);

  useEffect(() => {
    if (state) {
      setValue(state?.value);
    }
  }, []);

  useEffect(() => {
    FetchAllCount();
  }, [debouncedSearchTerm]);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_layout">
        <div className="dashboard">
          <h2 className="mn_hdng">{t.sideBar.manageCustomers}</h2>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={getUserCsv}
                disabled={rows?.length === 0 ? true : false}
              >
                <FileDownloadIcon /> {t.main.exportCsv}
              </Button>
            </Box>
          </Box>
          <div style={{ margin: 20 }}></div>
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab
                label={`${t.main.pending}${userCount?.pending ? ` (${userCount?.pending})` : ""}`}
                {...a11yProps(0)}
              />
              <Tab
                label={`${t.main.approved}${userCount?.activate ? ` (${userCount?.activate})` : ""}`}
                {...a11yProps(1)}
              />
              <Tab
                label={`${t.main.rejected}${userCount?.rejected ? ` (${userCount?.rejected})` : ""}`}
                {...a11yProps(2)}
              />
              <Tab
                label={`${t.main.deactivate}${userCount?.deactivate ? ` (${userCount?.deactivate})` : ""}`}
                {...a11yProps(3)}
              />
            </Tabs>

            <CustomTabPanel value={value} index={0}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>

                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 400,
                        }}
                      >
                        {t.main.address}
                      </TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>
                      <TableCell>{t.main.accountStatus}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noUserFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-users/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + ` ` + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell
                            style={{
                              minWidth: 350,
                              textWrap: "wrap",
                            }}
                          >
                            {row?.address?.business_address || "-"}
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  justifyContent: "space-between",
                                  display: "flex",
                                }}
                              >
                                <Button
                                  value="Reject"
                                  onClick={() => {
                                    setRejectOpen(true);
                                    setSelectedId(row?.id);
                                  }}
                                  style={{
                                    backgroundColor: "red",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.reject}
                                </Button>
                                <div style={{ margin: 8 }}></div>
                                <Button
                                  value="Approve"
                                  style={{
                                    backgroundColor: "green",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                  onClick={() => ApproveReject(row?.id, 5)}
                                >
                                  {t.main.accept}
                                </Button>
                              </div>
                            }
                          </TableCell>
                          <TableCell>
                            <Switch
                              defaultChecked={row.is_active}
                              onChange={(e) => {
                                const isChecked = !e.target.checked;
                                changeUserStatus(row?.id, isChecked);
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/details/${row?.id}`, {
                                    state: { value },
                                  })
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/usersform/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <RejectModal
                open={rejectOpen}
                setOpen={setRejectOpen}
                handleDelete={() => {
                  ApproveReject(selectedId, 4);
                }}
                name="Customer"
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>

                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>
                      <TableCell>{t.main.accountStatus}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noUserFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-users/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell
                            style={{
                              minWidth: 350,
                              textWrap: "wrap",
                            }}
                          >
                            {row?.address?.business_address || "-"}
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Button
                                  value="Reject"
                                  onClick={() => {
                                    setRejectOpen(true);
                                    setSelectedId(row?.id);
                                  }}
                                  style={{
                                    backgroundColor: "red",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.reject}
                                </Button>
                              </div>
                            }
                          </TableCell>
                          <TableCell>
                            <Switch
                              defaultChecked={row.is_active}
                              onChange={(e) => {
                                const isChecked = !e.target.checked;
                                // changeUserStatus(row._id, isChecked);
                                changeUserStatus(row?.id, isChecked);
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/details/${row?.id}`, {
                                    state: { value },
                                  })
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/usersform/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <RejectModal
                open={rejectOpen}
                setOpen={setRejectOpen}
                handleDelete={() => {
                  ApproveReject(selectedId, 4);
                }}
                name="Customer"
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>

                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>
                      {/* <TableCell>Account Status</TableCell> */}
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          {t.error.noUserFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-users/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>

                          <TableCell
                            style={{
                              minWidth: 350,
                              textWrap: "wrap",
                            }}
                          >
                            {row?.address?.business_address || "-"}
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Button
                                  value="Approve"
                                  style={{
                                    backgroundColor: "green",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                  onClick={() => ApproveReject(row?.id, 5)}
                                >
                                  {t.main.approved}
                                </Button>
                              </div>
                            }
                          </TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/details/${row?.id}`, {
                                    state: { value },
                                  })
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/usersform/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.fullName}</TableCell>
                      <TableCell>{t.main.phoneNumber}</TableCell>
                      <TableCell>{t.main.email}</TableCell>
                      <TableCell>{t.main.businessName}</TableCell>
                      <TableCell>{t.main.industryType}</TableCell>
                      <TableCell>{t.main.address}</TableCell>
                      <TableCell>{t.main.manageAccount}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          {t.error.noUserFound}
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-users/details/${row?.id}`, {
                                  state: { value },
                                })
                              }
                              className="user_img"
                            >
                              <img
                                src={
                                  row?.profile_picture?.media_url ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.full_name || "-"}</TableCell>

                          <TableCell>
                            {row?.country_code + row?.phone_no || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.business_name || "-"}</TableCell>

                          <TableCell>
                            {row?.industry_type === 1
                              ? "RETAILER"
                              : row?.industry_type === 2
                                ? "WHOLESALER"
                                : row?.industry_type === 3
                                  ? "DISTRIBUTER"
                                  : ""}
                          </TableCell>
                          <TableCell
                            style={{
                              minWidth: 350,
                              textWrap: "wrap",
                            }}
                          >
                            {row?.address?.business_address || "-"}
                          </TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/details/${row?.id}`, {
                                    state: { value },
                                  })
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-users/usersform/${row?.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          limit={limit}
          setLimit={setLimit}
          totalRecords={total_records}
        />
      ) : null}

      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteUser(selectedId)}
        name="Customer"
      />
    </div>
  );
};

export default ManageCustomers;
